module.exports = __webpack_public_path__ + "static/media/fantastic.732ab214.mp3";